import apiMiddleware from "../../../../api/apiMiddleware";

export const packageBookings = async (page = 1, search = "") => {
    try {
        const response = await apiMiddleware.get(
            `/package-bookings?page=${page}${search ? `&search=${search}` : ""}`
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};
